<template>
  <div @click="openFolder" class="icon-otzar otz-icon-square otz-icon">
    <!-- <svg class="icon-folder" width="15" height="14">
      <use v-bind="{ 'href': '#icons_' + nameIcon }" />
    </svg>-->
    {{ nameIcon }}
    <div
      v-if="listType == 'free'"
      style="position:absolute;top: 6px;left: 7px;font-size: 12px;"
      @click="openFolder"
      class="icon-otzar otz-icon-square otz-icon"
    >
      u
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    listType: {
      type: String,
      default: "book",
    },
    nameIcon: {
      type: String,
    },
  },

  methods: {
    openFolder() {
      this.$emit("click", this.nameIcon);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-folder {
  // width: 26px !important;
  // height: 26.4px;
  margin-right: 8px;
  cursor: pointer;
}
</style>
